import { render } from "./SiteGeneral.vue?vue&type=template&id=73127502"
import script from "./SiteGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteGeneral.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteGeneral.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73127502"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73127502', __exports__)) {
    api.reload('73127502', __exports__)
  }
  
  module.hot.accept("./SiteGeneral.vue?vue&type=template&id=73127502", () => {
    api.rerender('73127502', render)
  })

}


export default __exports__